import React, {useEffect, useState} from "react"
import {ProgressChartType} from "../progress-chart/progress-chart"
import InsightDataHelper from "../insight/insight-data-helper"
import {ChartScopeSettings} from "../insight/chart-scope-settings/chart-scope-settings"
import {ProgressChartArea} from "../progress-chart/progress-chart-area"
import {ChartScopeTransactions} from "../insight/chart-scope-transactions"
import {Heading, HeadingSmall} from "../../../components-shared/heading/heading"
import styles from "./income.module.scss"
import {TransactionRange} from "../../../domain/transaction-range"
import {Panel} from "../../../components-shared/panel/panel"
import {gaSendDashboardEvent} from "../../../services/analytics/google-analytics-helper"

export interface IncomeProps {
  type: ProgressChartType
  spendingData: InsightDataHelper
  chartScopeSettings: ChartScopeSettings
  transactionRange: TransactionRange | null
  refreshSpendingData: () => void
  className?: string
}

const incomeCategoryId = 1

export const Income : React.FC<IncomeProps> = ({ type, spendingData, chartScopeSettings, transactionRange, refreshSpendingData, className }) => {
  const [transactionsCategoryId, setTransactionsCategoryId] = useState<number | undefined>(incomeCategoryId)
  const [selectedProgressCategoryId, setSelectedProgressCategoryId] = useState<number | null>(incomeCategoryId)
  const [transactionsChartScopeSettings, setTransactionsChartScopeSettings] = useState<ChartScopeSettings>(chartScopeSettings)
  const [showTransactions, setShowTransactions] = useState<boolean>(true)

  useEffect(() => {
    setTransactionsChartScopeSettings(chartScopeSettings)
  }, [chartScopeSettings])

  const hasTransactions = spendingData !== null && spendingData.monthlySpendingData.months.length > 0

  const clickProgressCategoryMonth = (categoryId: number | undefined, monthIndex: number) => {
    if (spendingData === null) return
    setTransactionsChartScopeSettings({range: {monthStart: new Date(spendingData.monthlySpendingData.months[monthIndex].month)}, period: "month"})
    if (!selectedProgressCategoryId && categoryId !== undefined) setSelectedProgressCategoryId(categoryId)
    setTransactionsCategoryId(categoryId)
    setShowTransactions(true)
    gaSendDashboardEvent("Progress income chart select month")
  }

  const resetCategoryScope = (transactionsCategoryId !== incomeCategoryId)
    ? { text: "alles tonen", resetCategoryScope: () => {
      setTransactionsCategoryId(incomeCategoryId)
      setTransactionsChartScopeSettings({...chartScopeSettings})
    } }
    : undefined

  return <>
    <Panel className={className} fullWidth>
      <div className={styles.TitleContainer}>
        <Heading size="small">Inkomen door de tijd heen</Heading>
      </div>
      <ProgressChartArea
        type={type}
        spendingData={spendingData}
        incomeOrExpenses="income"
        showCo2={false}
        clickCategoryMonth={clickProgressCategoryMonth}
        selectedProgressCategoryId={selectedProgressCategoryId}
        noSubCategories={true}/>
    </Panel>

    {hasTransactions && showTransactions && <div className={styles.Transactions}>
      <HeadingSmall>Transacties</HeadingSmall>
      <ChartScopeTransactions
        chartScopeSettings={transactionsChartScopeSettings}
        categoryId={transactionsCategoryId}
        setCategoryId={setTransactionsCategoryId}
        monthlySpendingData={spendingData.monthlySpendingData}
        transactionRange={transactionRange}
        refreshSpendingData={refreshSpendingData}
        impactFirst={false}
        displayCategoryScope={true}
        showFilter={false}
        resetCategoryScope={resetCategoryScope}/>
    </div>}
  </>
}
